module.exports = __webpack_public_path__ + "static/media/gf_2.bc30905d.jpg";